require('./emptyState.styles');
const template = require('./emptyState.template');

class EmptyStateController implements ng.IComponentController {
    public static $inject = [
    ];

    public readonly title:string;
    public readonly message:string;
    /**
     * Material icon string to be used as main graphic
     */
    public readonly icon:string = this.icon || 'error' ;

    /**
     * Material icon string to be used as background graphic
     */
    public readonly background:string;
    public get canClick() {
        return !!this.onClick;
    }

    private onClick?:() => void;

    constructor(
    ) {
    }

    public click(){
        if(this.onClick){
            this.onClick();
        }
    }
}

export const EmptyStateComponent:ng.IComponentOptions = {
    controller: EmptyStateController,
    controllerAs: 'vm',
    transclude:{
        icon: '?emptyStateIcon',
        accent: '?emptyStateAccent'
    },
    template,
    bindings: {
        icon: '@?',
        title: '@',
        message: '@',
        onClick: '&?'
    }    
}




// WEBPACK FOOTER //
// ./src/sharebase/components/emptyState/emptyState.component.ts